import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Image from "next/image";
import { ImageWrapper } from "./Image.styles";
// Generic <Image /> component, preparation work for PAGES-70
var ResponsiveImage = function(_param) /*#__PURE__*/ {
    var roundedBorder = _param.roundedBorder, props = _object_without_properties(_param, [
        "roundedBorder"
    ]);
    return _jsx(ImageWrapper, {
        roundedBorder: roundedBorder,
        children: /*#__PURE__*/ _jsx(Image, _object_spread({}, props))
    });
};
export { ResponsiveImage as Image };
